import loadable from '@loadable/component';
import * as React from 'react';
import Gallery, { IMediaItem } from '../../../components/Gallery/Gallery';
import PriceTable from '../../../components/PriceTable/PriceTable';
import { packageCruiseEnabled } from '../../../helpers/packageCruise';
import { ICruiseIconOption, IPackageCruise, ISail } from '../../../interfaces';
import DreamLinesPackageArea from '../components/DreamLinesPackageArea';
import CruiseStageDescriptionList from './CruiseStageDescriptionList';
const DreamDeal = loadable(() => import('../../../components/DreamDeal/DreamDeal'));
export interface ICruiseStageOverview {
    isDesktop?: boolean;
    gallery: string[] | IMediaItem[];
    zone: string;
    companyTitle: string;
    shipTitle: string;
    startHarbour: string;
    endHarbour?: string;
    nightsString?: string;
    dateRange?: string;
    icons?: {
        icon: ICruiseIconOption;
        text: string;
    }[];
    cruiseId: number;
    cruiseTitle?: string;
    dreamDeal: false | Record<string, any>;
    sails: ISail[];
    packageCruise: IPackageCruise | null;
    currency: string;
    countryCode: string;
}

const CruiseStageOverview = (props: ICruiseStageOverview) => {
    const {
        gallery,
        zone = '',
        companyTitle = '',
        shipTitle = '',
        startHarbour = '',
        endHarbour = '',
        nightsString = '',
        dateRange = '',
        icons = null,
        cruiseId = 0,
        cruiseTitle = '',
        dreamDeal = false,
        sails = [],
        packageCruise,
        currency,
        countryCode,
    } = props;

    const descriptionListObj = {
        zone,
        companyTitle,
        shipTitle,
        startHarbour,
        endHarbour,
        nightsString,
        dateRange,
        icons,
        cruiseId,
        sails,
    };

    const compName = 'cruise-stage-overview';

    return (
        <div className={`${compName}`}>
            <div
                className={`${compName}__images gallerySlider col-xs-12 col-is-6 col-sm-6 noPadding`}
            >
                <Gallery images={gallery} cruiseTitle={cruiseTitle} />
            </div>
            <div className={`${compName}__pricing col-xs-12 col-is-6 col-sm-6 noPadding`}>
                {/* {packageCruise && packageCruiseEnabled(countryCode) && (
                    <DreamLinesPackageArea currency={currency} packageCruise={packageCruise} />
                )} */}
                {dreamDeal ? (
                    <DreamDeal text={dreamDeal.description} countDownDate={dreamDeal.valid_to} />
                ) : null}
                <PriceTable startHarbour={startHarbour} endHarbour={endHarbour} />
            </div>
            <div className={`${compName}__description-list col-xs-12 col-md-6 noPadding`}>
                <CruiseStageDescriptionList {...descriptionListObj} />
            </div>
        </div>
    );
};
export default CruiseStageOverview;
